<script>
import {mapActions, mapState} from "vuex";
import CustomPagination from "@/driver/components/_CustomPagination.vue";

export default {
  name: "DriverMasterGeneralWastes",
  components: {
    CustomPagination
  },
  mixins: [],
  data () {
    return {
      page: 1,
      perPage: 50,
      totalVisible: 7,
      searchForm: {
        code: null,
        name: null,
        locationCode: null,
        locationName: null,
        unregisterLocation: false,
      },
      withDeleted: false,
      tableHeaders: [
        { text: '事業者コード', value: 'code', width: '10%' },
        { text: '事業者名', value: 'name', width: '30%' },
        { text: '郵便番号', value: 'zip_code', width: '10%', align: 'center' },
        { text: '住所', value: 'address', width: '30%' },
        { text: '事業場警告', value: 'location_registered', align: 'center', width: '10%' },
        { text: '詳細・編集', value: 'editable', align: 'end', width: '10%' },
      ],
      generalWasteDisposals: [],
      /** 最終報告状況 */
    }
  },
  computed: {
    ...mapState('DriverMasterGeneralWasteDisposal', {
      pagination: 'pagination',
      searchCondition: 'condition',
    }),
  },
  watch: {},
  created () {
    if (this.$route.params.resetCondition) {
      this.resetState()
    }
    if (this.$route.params.resetPagination) {
      this.resetPagination()
    }
    this.searchForm.code = this.searchCondition.code
    this.searchForm.name = this.searchCondition.name
    this.searchForm.locationCode = this.searchCondition.location_code
    this.searchForm.locationName = this.searchCondition.location_name
    this.searchForm.unregisterLocation = this.searchCondition.unregister_location
    this.page = this.pagination.current_page
    this.perPage = this.searchCondition.limit
    this.search();
  },
  methods: {
    ...mapActions("DriverMasterGeneralWasteDisposal", {
      fetchGeneralDisposals: "index",
      resetState: "resetState",
      resetPagination: "resetPagination",
    }),

    /**
     * 検索ボタン クリックイベント
     */
    searchButtonClickEvent () {
      this.page = 1
      this.search()
    },

    /**
     * 一般廃棄物処分業者の追加ボタン クリックイベント
     */
    addButtonClickEvent () {
      this.$router.push({name: 'DriverMasterGeneralWasteDisposalNew'})
    },

    /**
     * 詳細ボタン クリックイベント
     * @param item
     */
    showButtonClickEvent (item) {
      this.$router.push({name: 'DriverMasterGeneralWasteDisposal', params: { id: item.id }})
    },

    /**
     * 編集ボタン クリックイベント
     * @param item
     */
    editButtonClickEvent (item) {
      this.$router.push({name: 'DriverMasterGeneralWasteDisposalEdit', params: {id: item.id }})
    },

    /**
     * ページボタン クリックイベントのコールバック
     * @param page
     */
    pageChangeCallback (page) {
      this.page = page;
      this.search()
    },

    /**
     * 一覧表示件数 チェンジイベントのコールバック
     * @param perPage
     */
    perPageChangeCallback(perPage) {
      this.perPage = perPage
      this.page = 1
      this.search()
    },

    /**
     * 一覧検索の実行
     */
    search () {
      const params = {
        code: this.searchForm.code,
        name: this.searchForm.name,
        location_code: this.searchForm.locationCode,
        location_name: this.searchForm.locationName,
        unregister_location: this.searchForm.unregisterLocation,
        page: this.page,
        limit: this.perPage,
        format: 'json'
      }
      this.fetchGeneralDisposals({ conditions: params }).then((content) => {
        this.generalWasteDisposals = content.traders
      })
    },

  },
}
</script>

<template>
  <v-container fluid>
    <!-- ヘッダー -->
    <v-row>
      <v-col cols="12">
        <h2>
          <v-icon class="mr-2">
            mdi-earth
          </v-icon>
          一般廃棄物処分業者
        </h2>
        <v-spacer class="mt-2" />
      </v-col>
    </v-row><!-- /ヘッダー -->

    <v-row>
      <v-col>
        <v-expansion-panels accordion>
          <v-expansion-panel>
            <v-expansion-panel-header class="panel-header-color panel-selectable">
              <strong>
                <v-icon class="panel-header-color">
                  mdi-magnify
                </v-icon>
                &nbsp;条件を指定して検索
              </strong>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="searchForm.code"
                        dense
                        hide-details="auto"
                        label="事業者コード"
                        clearable
                        outlined
                        persistent-placeholder
                        rounded
                        @blur="searchButtonClickEvent()"
                        @click:clear="searchForm.code = null; searchButtonClickEvent()"
                      />
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="searchForm.name"
                        dense
                        hide-details="auto"
                        label="事業者名"
                        clearable
                        outlined
                        persistent-placeholder
                        placeholder="部分一致で検索"
                        rounded
                        @blur="searchButtonClickEvent()"
                        @click:clear="searchForm.name = null; searchButtonClickEvent()"
                      />
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="searchForm.locationCode"
                        dense
                        hide-details="auto"
                        label="事業場コード"
                        clearable
                        outlined
                        persistent-placeholder
                        placeholder=""
                        rounded
                        @blur="searchButtonClickEvent()"
                        @click:clear="searchForm.locationCode = null; searchButtonClickEvent()"
                      />
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="searchForm.locationName"
                        dense
                        hide-details="auto"
                        label="事業場名"
                        clearable
                        outlined
                        persistent-placeholder
                        placeholder="部分一致で検索"
                        rounded
                        @blur="searchButtonClickEvent()"
                        @click:clear="searchForm.locationName = null; searchButtonClickEvent()"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="3">
                      <v-checkbox
                        v-model="searchForm.unregisterLocation"
                        dense
                        hide-details="auto"
                        label="事業場警告のみ表示"
                        @change="searchButtonClickEvent()"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="primary"
                    @click="searchButtonClickEvent"
                  >
                    <v-icon>mdi-magnify</v-icon>&nbsp;検索
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="text-right">
        <v-btn
          color="primary"
          @click="addButtonClickEvent"
        >
          一般廃棄物処理業者の追加&nbsp;<v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <custom-pagination
          :page-number="page"
          :per-page="perPage"
          :pagination="pagination"
          :total-visible="totalVisible"
          @pageChanged="pageChangeCallback"
          @perPageChanged="perPageChangeCallback"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card flat class="rounded-card">
          <v-card-text>
            <v-data-table
              :headers="tableHeaders"
              :items="generalWasteDisposals"
              :items-per-page="-1"
              hide-default-footer
              disable-pagination
              disable-sort
            >
              <template v-slot:[`item.name`]="{ item }">
                <div class="line-clamp one-clamp" :title="item.name">{{ item.name }}</div>
              </template>

              <template v-slot:[`item.address`]="{ item }">
                <div class="line-clamp one-clamp" :title="item.address">{{ item.address }}</div>
              </template>

              <template v-slot:[`item.location_registered`]="{ item }">
                <v-icon
                  v-if="!item.location_registered"
                  color="red"
                >
                  mdi-block-helper
                </v-icon>
              </template>

              <template v-slot:[`item.editable`]="{item}">
                <v-btn
                  v-if="$vuetify.breakpoint.smAndUp"
                  icon
                  color="info darken-2"
                  @click="showButtonClickEvent(item)"
                >
                  <v-icon>mdi-file-document-outline</v-icon>
                </v-btn>
                <v-btn
                  v-else
                  text
                  color="info"
                  @click="showButtonClickEvent(item)"
                >
                  参照
                </v-btn>
                <v-btn
                  v-if="$vuetify.breakpoint.smAndUp"
                  color="info darken-2"
                  icon
                  @click="editButtonClickEvent(item)"
                >
                  <v-icon>mdi-note-edit</v-icon>
                </v-btn>
                <v-btn
                  v-else
                  text
                  color="info"
                  @click="editButtonClickEvent(item)"
                >
                  編集
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <custom-pagination
          :page-number="page"
          :per-page="perPage"
          :pagination="pagination"
          :total-visible="totalVisible"
          @pageChanged="pageChangeCallback"
          @perPageChanged="perPageChangeCallback"
        />
      </v-col>
    </v-row>

  </v-container>
</template>

<style scoped lang="scss">

</style>
